import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// Components
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import PrimaryButton from "../../elements/primary-button";
import { selectCartItemsState, selectShowCartRefreshBanner } from "../../selectors/application";
import { getCart, removeCartItem } from "../../services/cartService";
import { showCartRefreshBanner, hideCartRefreshBanner, updateCartAction } from "../../redux/actions/actions";
import { connect } from "react-redux";
import { mappingCartMergeToCartItem } from "../../mappings/ProductDetail";
import transform from "../../utils/jsonpath-object-transform";

import api from "../../utils/api";
// Styles
import "./style.scss";
import { canUseDOM } from "../../utils";

const CartRefreshBanner = ({ fields, user, rendering, cartItems, sessionId, updateCart, isCartRefreshBannerVisible, showCartRefreshBanner, hideCartRefreshBanner, lang, isInCart }) => {
  return <></>;
  const { titleType, titleBody, body, refreshCartButton, cartPage } = fields;
  const [productsToremove, setProductsToremove] = useState([]);
  const pathname = canUseDOM() ? window.location.pathname : "";
  useEffect(() => {
    const refreshBanner = setTimeout(checkCartItemsForStock, 5 * 60 * 1000);
    return () => clearInterval(refreshBanner);
  }, [isCartRefreshBannerVisible, cartItems]);

  useEffect(() => {
    if (pathname === cartPage?.value?.href) {
      checkCartItemsForStock();
    }
  }, [pathname]);

  const checkCartItemsForStock = async () => {
    let currentShoppingCart = await getCart(lang);
    let mappingResultToCartItem = transform(currentShoppingCart, mappingCartMergeToCartItem(currentShoppingCart));

    getUsableStock(mappingResultToCartItem.items);
  };

  const refreshCart = async () => {
    for (var i = 0; i < productsToremove.length; i++) {
      let product = productsToremove[i];
      // only remove so may items that is over the stock limit.
      // ex: 2 items is stock 4 in cart.
      // only remove 2, i.e. the number of the stock limit
      let quantityToRemove = product.quantity - product.usableStock;

      const res = await removeCartItem(product.skuId, quantityToRemove);
      updateCart(res.obj);
    }

    hideCartRefreshBanner();
  };

  async function getUsableStock(items) {
    let _items = [];
    for (const item of items) {
      await api.product.sku.get({ skuId: item.skuId }).then(skuResponse => {
        let _item = {
          skuId: item.skuId,
          quantity: item.quantity,
          usableStock: skuResponse.obj.usableStock
        };
        _items.push(_item);
      });
    }

    let itemsToRemove = _items.filter(item => item.quantity > item.usableStock);

    console.log("Items sold out", itemsToRemove);

    if (itemsToRemove.length) {
      setProductsToremove(itemsToRemove);
      showCartRefreshBanner();
    }
  }

  return (
    <div>
      {isCartRefreshBannerVisible && (
        <div className="cart-refresh-banner grid" datasourceid={rendering.dataSource}>
          <div className="cart-refresh-banner__content">
            <div className="text-wrapper">
              <Heading html={titleBody} type={titleType} />
              <BodyText html={body.value} />
            </div>
            <PrimaryButton
              {...{
                ...refreshCartButton,
                iconName: {
                  value: {
                    alt: refreshCartButton?.fields.iconName.value.alt || '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"> <path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" /></svg>'
                  }
                },
                buttonText: refreshCartButton?.fields.buttonText.value,
                colorScheme: refreshCartButton?.colorScheme || {
                  fields: { phrase: { value: "green" } }
                },
                callback: refreshCart
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

CartRefreshBanner.propTypes = {
  heading: PropTypes.object,
  body: PropTypes.string,
  refreshCartButton: PropTypes.object
};
const mapStateToProps = state => ({
  cartItems: selectCartItemsState(state),
  isCartRefreshBannerVisible: selectShowCartRefreshBanner(state),
  sessionId: state.sessionId,
  user: state.user
});
const mapDispatchToProps = dispatch => ({
  updateCart: data => dispatch(updateCartAction(data)),
  hideCartRefreshBanner: () => dispatch(hideCartRefreshBanner()),
  showCartRefreshBanner: () => dispatch(showCartRefreshBanner()),
  dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(CartRefreshBanner);
